import { CheckboxGroupButtons } from '@/components/_common';
import ReportSelectMonthFields from '@/components/_common/ReportSelectMonthFields';
import {
  GenereteWorkOrderByInvoiceDateType,
  GenereteWorkOrderByInvoiceSituation,
  GenereteWorkOrderByInvoiceType,
  GenereteWorkOrderSituation,
} from '@/core/domain/reports/workOrderReport/workOrderReport.enums';
import { GenereteWorkOrderByInvoiceFormValues } from '@/core/domain/reports/workOrderReport/workOrderReport.types';
import { Checkbox, Col, Form, Radio, Row, Typography } from 'antd';
import { FormInstance } from 'antd/es/form/Form';

interface Props {
  form: FormInstance<GenereteWorkOrderByInvoiceFormValues>;
}

export default function OsXInvoiceForm({ form }: Props) {
  const workOrderSituation = {
    [GenereteWorkOrderSituation.Open]: 'Abertos',
    [GenereteWorkOrderSituation.Authorized]: 'Autorizados',
    [GenereteWorkOrderSituation.Closed]: 'Fechados',
    [GenereteWorkOrderSituation.Canceled]: 'Cancelados',
  };

  const invoiceSituation = {
    [GenereteWorkOrderByInvoiceSituation.InTyping]: 'Em Digitação',
    [GenereteWorkOrderByInvoiceSituation.Authorized]: 'Autorizado',
    [GenereteWorkOrderByInvoiceSituation.Processing]: 'Em Processamento',
    [GenereteWorkOrderByInvoiceSituation.ProcessingCancellation]:
      'Em Cancelamento',
    [GenereteWorkOrderByInvoiceSituation.Replaced]: 'Substituída',
    [GenereteWorkOrderByInvoiceSituation.Denied]: 'Negado',
    [GenereteWorkOrderByInvoiceSituation.Canceled]: 'Cancelado',
  };

  const workOrderDate = {
    [GenereteWorkOrderByInvoiceDateType.EntryDate]: 'Entrada',
    [GenereteWorkOrderByInvoiceDateType.AuthorizationDate]: 'Autorização',
    [GenereteWorkOrderByInvoiceDateType.ClosingDate]: 'Fechamento',
  };

  return (
    <Form form={form} layout="vertical">
      <ReportSelectMonthFields
        form={form}
        dateFilter={
          <Form.Item
            name="workOrderDate"
            label={
              <Typography.Title level={5} style={{ margin: 0 }}>
                Filtrar por data de
              </Typography.Title>
            }
            initialValue={GenereteWorkOrderByInvoiceDateType.AuthorizationDate}
            noStyle
          >
            <Radio.Group
              buttonStyle="solid"
              optionType="button"
              options={Object.entries(workOrderDate).map(([value, label]) => ({
                value,
                label,
              }))}
              size="large"
            />
          </Form.Item>
        }
      />

      <Row gutter={[12, 16]}>
        <Col span={24}>
          <Form.Item
            name="workOrderSituation"
            label={
              <Typography.Title level={5} style={{ margin: 0 }}>
                Situação da O.S.
              </Typography.Title>
            }
            initialValue={[GenereteWorkOrderSituation.Closed]}
          >
            <CheckboxGroupButtons
              options={Object.entries(workOrderSituation).map(
                ([value, label]) => ({ value, label }),
              )}
            />
          </Form.Item>
        </Col>

        <Col span={24}>
          <Form.Item name="withoutInvoice" valuePropName="checked">
            <Checkbox>
              Filtrar por Orçamentos Fechados/Autorizados sem vínculo com nota
              fiscal
            </Checkbox>
          </Form.Item>
        </Col>

        <Col span={24}>
          <Form.Item
            name="invoiceSituation"
            label={
              <Typography.Title level={5} style={{ margin: 0 }}>
                Situação da Nota Fiscal
              </Typography.Title>
            }
            initialValue={[GenereteWorkOrderByInvoiceSituation.Authorized]}
          >
            <CheckboxGroupButtons
              options={Object.entries(invoiceSituation).map(
                ([value, label]) => ({ value, label }),
              )}
            />
          </Form.Item>
        </Col>

        <Col span={24}>
          <Form.Item
            name="invoiceType"
            label={
              <Typography.Title level={5} style={{ margin: 0 }}>
                Tipo de Nota Fiscal
              </Typography.Title>
            }
            initialValue={[GenereteWorkOrderByInvoiceType.NFE]}
          >
            <CheckboxGroupButtons
              options={Object.values(GenereteWorkOrderByInvoiceType).map(
                (value) => ({ value, label: value }),
              )}
            />
          </Form.Item>
        </Col>

        <Col span={24}>
          <Form.Item name="hasFinancialRecord" valuePropName="checked">
            <Checkbox>Com registro financeiro</Checkbox>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
}
